import HeaderSkeleton from "./HeaderSkeleton";
import Skeleton from "./Skeleton";

export default function ProfileSkeleton() {
  return (
    <div className="-m-6 flex flex-col gap-12 overflow-x-hidden">
      <div className="-m-6 flex flex-1 flex-col p-6">
        <div className="h-60 w-full bg-gray-50" />
        <div className="flex gap-6 px-8">
          <div className="-mt-10 size-40 rounded-full bg-gray-200" />
          <div className="flex flex-1 flex-col gap-5">
            {" "}
            <HeaderSkeleton />
            <div className="flex gap-5">
              <div className="flex min-w-0 flex-1 flex-col gap-1 ps-8">
                <Skeleton size="xl" className="h-[38px] w-32" fixed={false} />
                <Skeleton size="lg" className="w-full" fixed={false} />
              </div>
              <Skeleton size="xl" className="h-[38px] w-28" />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5 px-8">
        <div className="flex gap-4">
          <Skeleton size="lg" className="w-28" fixed={false} />
          <Skeleton size="lg" className="w-28" fixed={false} />
          <Skeleton size="lg" className="w-28" fixed={false} />
          <Skeleton size="lg" className="w-28" fixed={false} />
          <Skeleton size="lg" className="w-28" fixed={false} />
          <Skeleton size="lg" className="w-28" fixed={false} />
          <Skeleton size="lg" className="w-28" fixed={false} />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton size="md" className="w-40" fixed={false} />
          <Skeleton size="sm" className="w-60" fixed={false} />
        </div>

        <div className="grid grid-cols-3">
          <Skeleton size="sm" className="w-40" fixed={false} />
          <div>
            <Skeleton size="sm" className="w-32" fixed={false} />
            <div className="flex justify-between rounded-lg bg-gray-50 p-2">
              <div className="h-[72px] w-[72px] rounded-full bg-gray-200" />
              <div className="flex gap-2">
                <Skeleton size="sm" className="w-[78px]" fixed={false} />
                <Skeleton size="sm" className="w-[78px]" fixed={false} />
              </div>
            </div>
          </div>
        </div>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="grid grid-cols-3">
            <div />
            <div>
              <Skeleton size="sm" className="w-32" fixed={false} />
              <div className="flex flex-col gap-1">
                <Skeleton size="2xl" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
